// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1C5Fk","field":"styles_field__1yZtJ","fieldCol":"styles_fieldCol__3ZaUk","diffCol":"styles_diffCol__3ipYZ","diff":"styles_diff__3Ds9S"};